import type { SVGProps } from "react";
import * as React from "react";

export const AddIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    className="fill-current"
    {...props}
  >
    <path
      d="M12.0001 5.6001C12.4419 5.6001 12.8001 5.95827 12.8001 6.4001V11.2001H17.6001C18.0419 11.2001 18.4001 11.5583 18.4001 12.0001C18.4001 12.4419 18.0419 12.8001 17.6001 12.8001H12.8001V17.6001C12.8001 18.0419 12.4419 18.4001 12.0001 18.4001C11.5583 18.4001 11.2001 18.0419 11.2001 17.6001V12.8001H6.4001C5.95827 12.8001 5.6001 12.4419 5.6001 12.0001C5.6001 11.5583 5.95827 11.2001 6.4001 11.2001H11.2001V6.4001C11.2001 5.95827 11.5583 5.6001 12.0001 5.6001Z"
      fill="currentColor"
    />
  </svg>
);
